import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

const SKELETON_ITEM_HEIGHT = 16;

interface Props {
  height: number;
}

export const CategoryTabsSkeleton: React.FC<Props> = ({ height }) => {
  const [styles, theme] = useStyles();
  return (
    <View
      style={[styles.skeletonRow, { height }]}
      testID="category-tabs-skeleton"
    >
      {[64, 40, 56, 32].map((width, index) => (
        <AnimatedSkeletonLoader
          borderRadius={theme.sk.radii.radiusSmall}
          height={SKELETON_ITEM_HEIGHT}
          key={index}
          style={styles.skeletonItem}
          width={width}
        />
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  skeletonItem: {
    marginTop: 0,
  },
  skeletonRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceMedium,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
